export const pathsRequireLogin = ['/order-payment/pay'];
export const SpecificPaths = ['/car-config/', '/test-drive', '/purchase/product-order-page', '/van-configurator', '/presale-testdrive']
export const specificPathForDouYin = ['/presale-testdrive']
export const specificPathForSalesAppDisplay = ['/test-drive', '/purchase/product-order-page', '/presale-testdrive']

export const SuggestionAPI = '/api/search/suggestions'
export const SearchResultURL = '/search'


export const FloatingButtonToolbarConfig = [
  { key: 'Online Consultation', icon: '/floating-button/floating-btn-im.png', label: '在线客服' },
  { key: 'Vehicle List', icon: '/floating-button/floating-btn-vehicle-list.png', label: '探索车型' },
  { key: 'Financial Credit Limit', icon: '/floating-button/floating-btn-credit-limit.png', label: '金融额度' },
  { key: 'Find Dealer', icon: '/floating-button/floating-btn-dealer.png', label: '找经销商' },
  { key: 'Financial Calculator', icon: '/floating-button/floating-btn-fc.png', label: '金融试算', douyinmnp: true, salesapp: true },
  { key: 'Purchase Car', icon: '/floating-button/floating-btn-purchase-car.png', label: '在线购车', douyinmnp: false, salesapp: true },
  { key: 'Download Brochure', icon: '/floating-button/floating-btn-download-carbook.png', label: '下载车书', douyinmnp: true, salesapp: true },
  { key: 'Cross Model Comparison', icon: '/floating-button/floating-btn-cross-model-comparison.png', label: '车型对比', douyinmnp: true, salesapp: true },
]


export const FINANCIAL_CREDIT_LIMIT_URL = "https://mbfs-jinrongtong-prod.mercedes-benz-finance.com.cn/credit-limit/landing?companyId=1&from=oneweb&platform=web"


export enum URL_SOURCE {
  DOUYIN_MNP = 'douyinmnp',
  SALES_APP = 'salesapp',
}
